import { useState, useEffect, useCallback } from "react";
import DraggableDualList from "../DraggableDualList/DraggableDualList";
import { useUserStore } from "../../contexts/userStore";
import { AccessIcons } from "../../utils/accessIcons";
import AccessGroupService from "../../services/AccessGroupService";
import { useAuth } from "../../contexts/auth";

function makeItemId(accessPoint) {
   return `${accessPoint.id}`;
}

function buildTree(groups, groupAccesses, includeSelected) {
   const groupMap = new Map();

   for (const group of groups) {
      const belongsToGroup = groupAccesses?.find(
         (ga) => ga.id === group.id
      );

      const shouldInclude = includeSelected ? !!belongsToGroup : !belongsToGroup;
      if (!shouldInclude) continue;

      const itemId = makeItemId(group);
      groupMap.set(itemId, {
         id: itemId,
         type: "item",
         label: group.name,
         icon: AccessIcons[group.type] ?? null,
         originalId: group.id,
         relationId: belongsToGroup?.id,
      });
   }

   return Array.from(groupMap.values());
}
function flattenSelectedItems(rightTree) {
   const selected = [];
   for (const node of rightTree) {
      const items = node.type === "group" ? node.children : [node];
      for (const item of items) {
         if (item.type === "item") {
            selected.push({
               id: item.id,
               relationId: item.relationId,
               originalId: item.originalId,
               value: item.id,
               label: item.label,
               icon: item.icon,
            });
         }
      }
   }
   return selected;
}

export function AccessGroupsDDL({
   groups,
   isLicenseScope = true,
   onChangeList,
}) {
   const { user } = useAuth();
   const { selectedCondominio } = useUserStore();
   const [groupsList, setGroupsList] = useState([]);
   const [initialLeft, setInitialLeft] = useState([]);
   const [initialRight, setInitialRight] = useState([]);
   const [ready, setReady] = useState(false);

   useEffect(() => {
      (async () => {
         if (isLicenseScope && !user?.userData?.selectedOrganizationId) return;
         if (!isLicenseScope && !selectedCondominio) return;

         let response;
         if (!isLicenseScope) {
            const { data } = await AccessGroupService.listOrganizationAccessGroups(user.userData.selectedOrganizationId);
            response = data;
         } else {
            const { data } = await AccessGroupService.listCondominiumAccessGroups(selectedCondominio);
            response = data;
         }
         setGroupsList(response);
      })();
   }, [
      selectedCondominio,
      isLicenseScope,
      user?.userData?.selectedOrganizationId,
   ]);

   useEffect(() => {
      if (!groupsList.length) return;

      const left = buildTree(groupsList, groups, false);
      const right = buildTree(groupsList, groups, true);

      setInitialLeft(left);
      setInitialRight(right);
      setReady(true);

      if (onChangeList) onChangeList(flattenSelectedItems(left), flattenSelectedItems(right));
   }, [groupsList]);

   const handleChange = useCallback(
      (leftTree, rightTree) => {
         if (onChangeList) onChangeList(flattenSelectedItems(leftTree), flattenSelectedItems(rightTree));
      },
      [onChangeList]
   );

   if (!ready) return null;

   return (
      <DraggableDualList
         labelLeft="Grupos Disponíveis"
         labelRight="Grupos Selecionados"
         initialLeft={initialLeft}
         initialRight={initialRight}
         onChange={handleChange}
      />
   );
}